import { useContext, useState } from "react";
import { CartContext } from "@/lib/cart_context.js";
import SavedItemRow from "@/components/saved_item_row.js";
function CartItems({ items, shared, resource_display, config }) {
  let cart;
  if (!shared) {
    cart = useContext(CartContext);
  } else {
    cart = { items: items };
  }
  const removeItem = (id) => {
    let ans = confirm("Are you sure?");
    if (ans) {
      cart.removeItem(id);
      setProducts((old) => old.filter((data) => data.id !== id));
    }
  };
  const [products, setProducts] = useState(items);
  let _products = cart.items?.length > 0 ? cart.items : products;

  return (
    <>
      <section className="lexcms-saved-items-table">
        <div className="lexcms-saved-items-table-header-container">
          <div className="lexcms-saved-items-table-headers">
            <p className="lexcms-saved-items-table-header-values">Product</p>
            <p className="lexcms-saved-items-table-header-values">
              Description
            </p>
            <p className="lexcms-saved-items-table-header-values">Resources</p>
          </div>
        </div>
        {_products?.length > 0 ? (
          _products.map((product, i) => {
            return (
              <SavedItemRow
                key={i}
                product={product}
                removeItem={removeItem}
                canEdit={!shared}
                config={config}
                resource_display={resource_display}
              />
            );
          })
        ) : (
          <div className="lexcms-no-results-found-text">
            You do not currently have any saved items.{" "}
          </div>
        )}
      </section>
    </>
  );
}

export default CartItems;
